import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-euro"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><g transform=\"translate(-1.375 -1.375)\" class=\"\"><path d=\"M32.1,28.4c-1.7,3-5,5-8.7,5\n\t\t\tc-5.5,0-10-4.5-10-10s4.5-10,10-10c3.7,0,6.9,2,8.7,5\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path></g><g class=\"\"><line x1=\"10.1\" x2=\"23.4\" y1=\"20.3\" y2=\"20.3\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"10.1\" x2=\"23.4\" y1=\"23.7\" y2=\"23.7\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line></g></g>", 1)
  ]), 16))
}
export default { render: render }